import {Injectable} from '@angular/core';

@Injectable()
export class Helper {

  genTimePicker() {
    const arrTime = [];
    for (let i = 8; i <= 19; i++) {
      if (i === 19) {
        arrTime.push(i.toString() + ':00');
      } else {
        for (let j = 0; j < 60; j += 15) {
          let a = '';
          if (i < 10) {
            if (j < 10) {
              a = '0' + i.toString() + ':0' + j.toString();
            } else {
              a = '0' + i.toString() + ':' + j.toString();
            }
          } else {
            if (j < 10) {
              a = i.toString() + ':0' + j.toString();
            } else {
              a = i.toString() + ':' + j.toString();
            }
          }
          arrTime.push(a);
        }
      }
    }
    return arrTime;
  }

  _unsubsribe(subscription) {
    if (subscription) {
      subscription.unsubscribe();
      subscription = null;
    }
  }

  /* Returns a function, that, as long as it continues to be invoked, will not
  * be triggered. The function will be called after it stops being called for
  * N milliseconds. If `immediate` is passed, trigger the function on the
  * leading edge, instead of the trailing.
  * */
  debounce(func, wait, immediate?) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  gotoInputError() {
    setTimeout(() => {
      const $firstError = $('.has-danger').first();
      if ($firstError.length > 0) {
        const $firstInput = $firstError.find('input').first();
        $firstInput.focus();
        return true;
      }
      return false;
    }, 200);
  }
}

export function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}



// WEBPACK FOOTER //
// /app/src/app/common/helper.ts